import {
  Accordion,
  AccordionButton,
  AccordionItem,
  AccordionPanel,
  Box,
} from "@chakra-ui/react";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import React, { useEffect, useRef, useState } from "react";
import ReactHtmlParser from "react-html-parser";
import Slider from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import star_image from "../../assets/images/star-white.svg";
import { IMAGE_URL, SITE_ID } from "../../services/apiConstants";
import { getHomeDetails } from "../../services/request/home";
import styles from "../Home/Home.module.css";
import card_arrow from "../../assets/images/card-arrow-gold.svg";
import DownArrow from "../../assets/images/down-arrow.svg";
import UpArrow from "../../assets/images/up-arrow.svg";
import sortObject from "../../utils/sortingObject";
import quote_img from "../../assets/images/quote.svg";
import quote_close_img from "../../assets/images/quote-close.svg";
import Mail from "../../commomComponents/mail";
import { OUR_OFFERINGS, OUR_OFFERINGS_NOTE } from "../../constants/strings";
import { useHistory } from "react-router-dom";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import Loader from "../../commomComponents/Loader";
import ReactPlayer from "react-player";
import HomeVideo from "../../assets/video/homeVideo.mov";
import SeoHelmet from "../../commomComponents/seoHelmet";
import ResponsiveDialog from "../../commomComponents/Dialog";
// import AOS from 'aos'
// import "aos/dist/aos.css";

const useStyles = makeStyles({
  root: {
    width: "30%",
    marginLeft: 25,
    height: "100%",
  },
  title: {
    fontSize: 26,
    fontWeight: "bold",
    display: "flex",
  },
  pos: {
    marginBottom: 12,
  },
});
const responsive = {
  superLargeDesktop: {
    // the naming can be any, depends on you.
    breakpoint: { max: 4000, min: 3000 },
    items: 3,
  },
  desktop: {
    breakpoint: { max: 1345, min: 1024 },
    items: 2,
  },
  desk: {
    breakpoint: { max: 3000, min: 1345 },
    items: 3,
  },
  tablet: {
    breakpoint: { max: 1024, min: 720 },
    items: 2,
  },
  preTablet: {
    breakpoint: { max: 720, min: 464 },
    items: 1,
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1,
  },
};

const Home = () => {
  const [home, setHome] = useState({
    About: "",
    Mid_banner: "",
    Mid_banner_Text: "",
    Mid_banner_Title: "",
    Mid_banner_Link: "",
    About_Title: "",
  });

  const [client, setClient] = useState({
    Message: "",
    Name: "",
    Designation: "",
    Dev_head_image: "",
  });

  const [banner, setBanner] = useState({
    Banner1: "",
    Banner2: "",
    Banner1_Text: "",
    Banner2_Text: "",
    Banner1_Title: "",
    Banner2_Title: "",
  });

  console.log("deployed v4");
  //   CustomDots
  const CustomDots = ({ onMove, index, onClick, active }) => {
    return (
      <div className={styles.list}>
        <li
          className={active ? styles.active : styles.inactive}
          onClick={() => onClick()}
        ></li>
      </div>
    );
  };

  const [Offerings, setOfferings] = useState([]);
  const [milestone, setMilestone] = useState([]);
  const [faqs, setFaqs] = useState([]);
  const [letterClass, setLetterClass] = useState("");

  const [isMobile, setIsMobile] = useState(false);
  const [isTablet, setIsTablet] = useState(false);
  const [isDesktop, setIsDesktop] = useState(false);
  const [loader, setLoader] = useState(false);

  useEffect(() => {
    const updateWindowDimensions = () => {
      const screenWidth = window.innerWidth;
      setIsMobile(screenWidth < 768);
      setIsTablet(screenWidth >= 768 && screenWidth < 1025);
      setIsDesktop(screenWidth >= 1025);
    };

    updateWindowDimensions();
    window.addEventListener("resize", updateWindowDimensions);

    return () => {
      window.removeEventListener("resize", updateWindowDimensions);
    };
  }, []);

  useEffect(() => {
    return setTimeout(() => {
      setLetterClass("text-animate-hover");
    }, 3000);
  }, [letterClass]);
  useEffect(() => {
    // AOS.init({
    //   duration: 2000
    // });
    document.title = "Home";
    const home = getHomeDetails();
    setLoader(true);
    home.then((data) => {
      home["About"] = data.data.abouts[0].text;
      home["About_Title"] = data.data.abouts[0].title;
      banner["Banner1"] = data.data.carousel[0].image;
      banner["Banner2"] = data.data.carousel[1].image;

      banner["Banner1_Text"] = data.data.carousel[0].description;

      banner["Banner2_Text"] = data.data.carousel[1].description;

      banner["Banner1_Title"] = data.data.carousel[0].title;

      banner["Banner2_Title"] = data.data.carousel[1].title;

      client["Message"] = data.data.message[0].text;

      client["Name"] = data.data.message[0].name;

      client["Designation"] = data.data.message[0].designation;

      client["Dev_head_image"] = data.data.message[0].image;

      home["Mid_banner"] = data.data.midbanner[0].image;

      home["Mid_banner_Text"] = data.data.midbanner[0].description;

      home["Mid_banner_Title"] = data.data.midbanner[0].title;

      // home["Mid_banner_Link"] = data.data.midbanner[0].link;
      setHome({ ...home });
      setClient({ ...client });
      setBanner({ ...banner });
      setOfferings(data.data.offerings);
      setMilestone(data.data.milestones);
      setFaqs(data.data.faq);
      setLoader(false);
    });
  }, []);
  const history = useHistory();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [history.location.pathname]);

  const scrollToTop = () => {
    window.scrollTo(0, 0);
  };
  // Function to handle navigation and scroll to top
  const handleLinkClick = (path) => {
    history.push(path);
    scrollToTop();
  };
  const handleNavigation = (path) => {
    history.push(path);
    scrollToTop();
  };
  const [showAllAbout, setShowAllAbout] = useState(false);
  const fullContentAbout = home["About"]; // Assuming home["About"] contains the full content

  const toggleContentAbout = () => {
    setShowAllAbout(!showAllAbout);
  };

  const [slideIndex, setSlideIndex] = useState(0); // Current slide index
  const videoRef = useRef(null);
  const intervalRef = useRef(null); // Use a ref to manage interval clearing
  const slideDurations = [15000, 10000, 20000]; // Timings for each slide
  const [timer, setTimer] = useState(null);
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const clearExistingInterval = () => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
    }
  };

  useEffect(() => {
    // Clear and set a new interval when slideIndex changes
    clearExistingInterval();

    intervalRef.current = setInterval(() => {
      setSlideIndex((prevIndex) => (prevIndex + 1) % slideDurations.length);
    }, slideDurations[slideIndex]);

    return clearExistingInterval; // Clean up on unmount or re-render
  }, [slideIndex]);

  useEffect(() => {
    // Reset video when on Slide 3
    if (slideIndex === 2 && videoRef.current) {
      videoRef.current.seekTo(0); // Reset video to the start
    }
  }, [slideIndex]);

  const handleVideoEnded = () => {
    console.log("Video ended. Looping back to Slide 1.");
    setSlideIndex(0); // Loop back to the first slide after video ends
  };

  const productSchema = {
    "@context": "https://schema.org",
    "@type": "Corporation",
    name: "ICICI Prudential Alternate Investments",
    url: "https://www.iciciprualternates.com/",
    logo: "https://www.iciciprualternates.com/static/media/logo.7de77484.svg",
    contactPoint: {
      "@type": "ContactPoint",
      telephone: "1800-268-0001",
      contactType: "customer service",
      areaServed: "IN",
      availableLanguage: "en",
    },
    sameAs: [
      "https://www.facebook.com/people/ICICI-Prudential-Alternate-Investments/61564527142001/",
      "https://x.com/ICICIAlternates",
      "https://www.instagram.com/iprualtinvestments/",
      "https://www.youtube.com/channel/UCx8zm0so0yzcIC3w2IdEndw",
      "https://www.linkedin.com/company/icici-prudential-amc-ltd",
    ],
  };

  return (
    <>
      <SeoHelmet
        title="ICICI Pru Alternates - Leading Wealth & Investment Management Company"
        description="ICICI Pru Alternates is amongst the top investment management firm, offering innovative solutions to help investors grow and preserve their wealth."
        url="https://www.iciciprualternates.com/"
        schemaJson={productSchema}
      />
      <div className={styles.home_container}>
        {loader === true ? (
          <Loader />
        ) : (
          <>
            {open && <ResponsiveDialog open={open} handleClose={handleClose} />}
            <Mail />
            <div className={styles.slides}>
              <Carousel
                showStatus={false}
                className={styles.slideshow}
                autoPlay={false} // Manual autoplay handled by useEffect
                infiniteLoop={false} // Looping managed manually
                selectedItem={slideIndex} // Controlled by slideIndex
                onChange={(index) => setSlideIndex(index)} // Sync slide changes
              >
                <div style={{ position: "relative" }}>
                  {banner["Banner2"] && (
                    <img
                      src={IMAGE_URL + banner["Banner2"] + SITE_ID}
                      alt="Portfolio management servies new user"
                    />
                  )}
                  <div>
                    <button
                      onClick={() => {
                        window.open(
                          "https://www.iciciprualternates.com/portal"
                        );
                      }}
                      className={styles.banner_button1}
                    >
                      Yes
                    </button>
                    <button
                      onClick={handleClickOpen}
                      className={styles.banner_button2}
                    >
                      No
                    </button>
                  </div>
                </div>

                <div style={{ position: "relative" }}>
                  {banner["Banner1"] && (
                    <img
                      src={IMAGE_URL + banner["Banner1"] + SITE_ID}
                      alt="Portfolio management servies new user"
                    />
                  )}
                  <div>
                    <button
                      onClick={() => {
                        window.dataLayer = window.dataLayer || [];
                        window.dataLayer.push({
                          event: "BannerClick",
                          inquiryType: "",
                          buttonName: "Know More",
                          email: "", // Encrypted email of the User using SHA-256 encryption
                          contactNumber: "", // Encrypted contact Number of the User using SHA-256 encryption
                          clientID: "",
                          queryMessage: "",
                          state: "",
                          pageSection: "banner2",
                          Category: "",
                          FAQ: "",
                        });
                        history.push("/invest-with-us");
                      }}
                      className={styles.banner_button}
                    >
                      Know More
                    </button>
                  </div>
                </div>
                <div
                  style={{
                    position: "relative",
                    width: "100%",
                    height: "auto",
                  }}
                >
                  <ReactPlayer
                    ref={videoRef}
                    url={HomeVideo}
                    width="100%"
                    height="100%"
                    display="initial"
                    position="absolute"
                    top="0"
                    left="0"
                    // controls={true}
                    playing={slideIndex === 2}
                    muted
                    onEnded={handleVideoEnded}
                    playsinline
                  />
                </div>
              </Carousel>
            </div>
            <div>
              <p className={styles.heading}>{home["About_Title"]}</p>
              <p className={styles.para}>
                {ReactHtmlParser(
                  showAllAbout
                    ? fullContentAbout
                    : fullContentAbout.split(".").slice(0, 2).join(". ") + "."
                )}
              </p>
              {showAllAbout && (
                <p className={styles.subpara}>
                  ^Prudential Plc. is not affiliated in any manner with
                  Prudential Financial, Inc., a company whose principal place of
                  business is in the United States of America or with the
                  Prudential Assurance Company, a subsidiary of M&G plc, a
                  company incorporated in United Kingdom.{" "}
                </p>
              )}
            </div>
            <div>
              <button
                onClick={toggleContentAbout}
                className={styles.view_more_button}
              >
                {showAllAbout ? (
                  <>
                    <span style={{ paddingRight: "10px" }}>View Less</span>
                    <img
                      src={UpArrow}
                      alt="button icon"
                      style={{ paddingBottom: "1px" }}
                    />
                  </>
                ) : (
                  <>
                    <span style={{ paddingRight: "10px" }}>{"View More"}</span>
                    <img
                      src={DownArrow}
                      alt="button icon"
                      style={{ paddingBottom: "1px" }}
                    />
                  </>
                )}
              </button>
            </div>

            <div className={styles.container}>
              <p className={styles.heading}>{OUR_OFFERINGS}</p>

              <div className={styles.cards}>
                <Slider
                  swipeable={true}
                  draggable={true}
                  showDots={true}
                  responsive={responsive}
                  ssr={true} // means to render carousel on server-side.
                  keyBoardControl={true}
                  customTransition="transform 0.5s ease-in-out"
                  infinite={true}
                  transitionDuration={100}
                  containerClass="carousel-container"
                  removeArrowOnDeviceType={[
                    "tablet",
                    "preTablet",
                    "mobile",
                    "superLargeDesktop",
                    "desktop",
                    "desk",
                  ]}
                  dotListClass="custom-dot-list-style"
                  itemClass="carousel-item-padding-40-px"
                  customDot={<CustomDots />}
                  autoPlay
                  autoPlaySpeed={3000}
                >
                  {sortObject(Offerings, "id").map((data) => {
                    let link = "";
                    switch (data.id) {
                      case 1:
                        link =
                          "/portfolio-management-service/contrarian-investing";
                        break;

                      case 2:
                        link =
                          "/portfolio-management-service/growth-leaders-strategy";
                        break;

                      case 3:
                        link = "/portfolio-management-service/value-strategy";
                        break;

                      case 4:
                        link =
                          "/portfolio-management-service/largecap-strategy";
                        break;

                      case 5:
                        link = "/portfolio-management-service/pipe-pms";
                        break;

                      case 6:
                        link = "/portfolio-management-service/ace-strategy";
                        break;
                    }

                    return (
                      <div className={styles.cardDesign}>
                        <Link
                          to={link}
                          onClick={() => {
                            window.dataLayer = window.dataLayer || [];
                            window.dataLayer.push({
                              event: "strategy_selected",
                              inquiryType: "",
                              buttonName: "",
                              email: "", // Encrypted email of the User using SHA-256 encryption
                              contactNumber: "", // Encrypted contact Number of the User using SHA-256 encryption
                              clientID: "",
                              queryMessage: "",
                              state: "",
                              pageSection: data.title,
                              Category: "",
                              FAQ: "",
                            });
                            handleNavigation();
                          }}
                        >
                          <h1 className={styles.cardTitle}>
                            <span className={styles.cardImage}>
                              <img src={star_image} alt="star-blue" />
                            </span>
                            {data.title}
                          </h1>
                          <div className={styles.cardText}>
                            {ReactHtmlParser(data.description)}
                          </div>
                          <img
                            src={card_arrow}
                            alt=""
                            style={{ float: "right" }}
                          />
                        </Link>
                      </div>
                    );
                  })}
                </Slider>
                <p className={styles.note}>
                  Kindly refer to the{" "}
                  <Link to="/investors-corner#RegulatoryDisclosure">
                    Disclosure Document
                  </Link>{" "}
                  for details of other strategies and including risk factors.
                </p>
              </div>
              {isDesktop && (
                <>
                  <div className={styles.milestone}>
                    {sortObject(milestone, "id").map((data) => (
                      <Card className={styles.root}>
                        <CardContent className={styles.center}>
                          <Typography className={styles.title}>
                            <p className={styles.milestone_count}>
                              {" "}
                              {data.count}{" "}
                            </p>
                            <p className={styles.milestone_title}>
                              {" "}
                              {data.title}{" "}
                            </p>
                          </Typography>
                          <Typography
                            variant="body1"
                            gutterBottom
                            component="div"
                            className={styles.milestone_para}
                          >
                            {data.text.split("!").map((text, index) => (
                              <React.Fragment key={index}>
                                {text.includes("As on 30th June 2023")
                                  ? null
                                  : text}
                                <br />
                              </React.Fragment>
                            ))}
                          </Typography>
                        </CardContent>
                      </Card>
                    ))}
                  </div>
                  <div className={styles.milestone}>
                    {sortObject(milestone, "id").map((data) => (
                      <div className={styles.root1}>
                        <Typography
                          variant="body1"
                          gutterBottom
                          component="div"
                          className={styles.milestone_para1}
                        >
                          {data.text.split("!").map((text, index) => (
                            <React.Fragment key={index}>
                              {text.includes("As on 30th June 2023") ? (
                                <div
                                  style={{ color: "maroon", fontSize: "14px" }}
                                >
                                  {text}
                                </div>
                              ) : null}
                              <br />
                            </React.Fragment>
                          ))}
                        </Typography>
                      </div>
                    ))}
                  </div>
                </>
              )}
              {isTablet && (
                <div className={styles.milestone}>
                  {sortObject(milestone, "id").map((data) => (
                    <React.Fragment key={data.id}>
                      <Card className={styles.root}>
                        <CardContent className={styles.center}>
                          <Typography className={styles.title}>
                            <p className={styles.milestone_count}>
                              {data.count}
                            </p>
                            <p className={styles.milestone_title}>
                              {data.title}
                            </p>
                          </Typography>
                          <Typography
                            variant="body1"
                            gutterBottom
                            component="div"
                            className={styles.milestone_para}
                          >
                            {data.text.split("!")[0]}
                            {"  "}
                            {/* Display only content before the "!" mark */}
                          </Typography>
                        </CardContent>
                      </Card>

                      {/* Check if there is content after the "!" mark */}
                      {data.text.split("!")[1] && (
                        <div className={styles.root1}>
                          <div className={styles.center}>
                            <Typography
                              variant="body1"
                              gutterBottom
                              component="div"
                              className={styles.milestone_para}
                              style={{ color: "maroon", fontSize: "14px" }}
                            >
                              {data.text.split("!")[1].trim()}{" "}
                              {/* Display content after the "!" mark */}
                            </Typography>
                          </div>
                        </div>
                      )}
                    </React.Fragment>
                  ))}
                </div>
              )}

              {isMobile && (
                <div className={styles.milestone}>
                  {sortObject(milestone, "id").map((data) => (
                    <React.Fragment key={data.id}>
                      <Card className={styles.root}>
                        <CardContent className={styles.center}>
                          <Typography className={styles.title}>
                            <p className={styles.milestone_count}>
                              {data.count}
                            </p>
                            <p className={styles.milestone_title}>
                              {data.title}
                            </p>
                          </Typography>
                          <Typography
                            variant="body1"
                            gutterBottom
                            component="div"
                            className={styles.milestone_para}
                          >
                            {data.text.split("!")[0]}
                            {"  "}
                            {/* Display only content before the "!" mark */}
                          </Typography>
                        </CardContent>
                      </Card>

                      {/* Check if there is content after the "!" mark */}
                      {data.text.split("*")[1] && (
                        <div className={styles.root1}>
                          <div className={styles.center}>
                            <Typography
                              variant="body1"
                              gutterBottom
                              component="div"
                              className={styles.milestone_para}
                              style={{ color: "maroon", fontSize: "14px" }}
                            >
                              {data.text.split("!")[1].trim()}{" "}
                              {/* Display content after the "!" mark */}
                            </Typography>
                          </div>
                        </div>
                      )}
                    </React.Fragment>
                  ))}
                </div>
              )}
              <div className={styles.image_container}>
                {home["Mid_banner"] && (
                  <img
                    src={IMAGE_URL + home["Mid_banner"] + SITE_ID}
                    alt=""
                    className={styles.banner_image}
                    loading="lazy"
                  />
                )}
                <div className={styles.midBannerContent}>
                  <p className={styles.mid_title_top_left}>
                    {home["Mid_banner_Title"]}
                  </p>
                  <p className={styles.mid_desc_top_left}>
                    {home["Mid_banner_Text"]}
                  </p>
                  <button
                    onClick={() => {
                      window.dataLayer = window.dataLayer || [];
                      window.dataLayer.push({
                        event: "requestCallback _click",
                        inquiryType: "",
                        buttonName: "Request a Call Back",
                        email: "", // Encrypted email of the User using SHA-256 encryption
                        contactNumber: "", // Encrypted contact Number of the User using SHA-256 encryption
                        clientID: "",
                        queryMessage: "",
                        state: "",
                        pageSection: "",
                        Category: "",
                        FAQ: "",
                      });
                      history.push("/invest-with-us");
                      handleLinkClick();
                    }}
                    className={styles.mid_banner_button}
                  >
                    Request a Call Back
                  </button>
                  {/* <button
               onClick={() => {
                window.open(home["Mid_banner_Link"], '_blank');
              }}
              className={styles.mid_banner_button1}
            >
              View Doc
            </button> */}
                </div>
              </div>
              <div className={styles.containers}>
                <p className={styles.heading}>
                  A message from our Principal- Sales, <br /> Alternate
                  Investments & PCG Business Development
                </p>
                <div className={styles.quote_image}>
                  <img src={quote_img} alt="" />
                </div>
                <div className={styles.message_div}>
                  <div className={styles.client_quote_text}>
                    <p>{ReactHtmlParser(client["Message"])}</p>

                    <div className={styles.quote_close_image}>
                      <img src={quote_close_img} alt="" />
                    </div>

                    <p className={styles.md_name}>{client["Name"]}</p>
                    <p className={styles.md_designation}>
                      {client["Designation"]}
                    </p>
                  </div>
                  <div className={styles.image_div}>
                    {client["Dev_head_image"] && (
                      <img
                        src={IMAGE_URL + client["Dev_head_image"] + SITE_ID}
                        alt="Sharzad Sethna Principal - Sales, Alternate Investments"
                        className={styles.dev_image}
                        loading="lazy"
                        style={{ filter: "grayscale(100%)", height: "363px" }}
                      />
                    )}
                  </div>
                </div>
              </div>
              {/* <div className={styles.section}>
          <div className={styles.containerEnd}>
            <p className={styles.investor_heading}>Investors FAQ's</p>
            <p className={styles.investor_para}>
              Some frequently asked questions and queries that you as an
              Investor might have.
            </p>
             
            <Accordion allowToggle isFocusable={true}>
              {faqs
                .sort((a, b) => a.id - b.id)
                .map((data) => {
                  return (
                    <AccordionItem>
                      {({ isExpanded }) => (
                        <>
                          <h2>
                            <AccordionButton
                              _expanded={{ bg: "#97291e", color: "white" }}
                              _hover={{ bg: "#97291e", color: "white" }}
                              padding={20}
                              fontSize={20}
                              backgroundColor="white"
                              color="#97291e"
                              border="1px solid #97291e"
                              fontFamily="Lato, sans-serif"
                            >
                              <Box
                                border={"transparent"}
                                width={"100%"}
                                textAlign="left"
                                fontWeight={400}
                              >
                                {data.question}
                              </Box>
                              {isExpanded ? (
                                <span className="crossPlus">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="20"
                                    height="20"
                                    viewBox="0 0 20 20"
                                  >
                                    <g
                                      fill="none"
                                      fill-rule="evenodd"
                                      opacity=".8"
                                    >
                                      <g>
                                        <path
                                          d="M0 0L24 0 24 24 0 24z"
                                          transform="translate(-1298 -5774) translate(1296 5772)"
                                        ></path>
                                        <path
                                          class="accord-arr"
                                          fill="white"
                                          fill-rule="nonzero"
                                          d="M13 7h-2v4H7v2h4v4h2v-4h4v-2h-4V7zm-1-5C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
                                          transform="translate(-1298 -5774) translate(1296 5772)"
                                        ></path>
                                      </g>
                                    </g>
                                  </svg>
                                </span>
                              ) : (
                                <span>
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="20"
                                    height="20"
                                    viewBox="0 0 20 20"
                                  >
                                    <g
                                      fill="none"
                                      fill-rule="evenodd"
                                      opacity="1"
                                    >
                                      <g>
                                        <path
                                          d="M0 0L24 0 24 24 0 24z"
                                          transform="translate(-1298 -5774) translate(1296 5772)"
                                        ></path>
                                        <path
                                          class="accord-arr"
                                          fill="#c9b16d"
                                          fill-rule="nonzero"
                                          d="M13 7h-2v4H7v2h4v4h2v-4h4v-2h-4V7zm-1-5C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
                                          transform="translate(-1298 -5774) translate(1296 5772)"
                                        ></path>
                                      </g>
                                    </g>
                                  </svg>
                                </span>
                              )}
                            </AccordionButton>
                          </h2>
                          <div className={styles.faqSection}>
                            <AccordionPanel>
                              <p className={styles.expandedContent}>
                                {ReactHtmlParser(data.answer)}
                              </p>
                            </AccordionPanel>
                          </div>
                        </>
                      )}
                    </AccordionItem>
                  );
                })}
            </Accordion>
          </div>
        </div> */}
            </div>
          </>
        )}
      </div>
    </>
  );
};
export default Home;
